import { LeadsDataSource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
export const getTopModelsBySourceLink = (source, dateRange) => {
    if (source === LeadsDataSource.VIN_SOLUTIONS) {
        return 'https://www.vinsolutions.com';
    }
    return getNvisionAnalyzeLeadsUrl(dateRange, true);
};
export const topModelsDataFormatter = (data) => ({
    chartData: ((data || {}).topModels || []).map(({ vehicleType, vehicleMake, vehicleModel, leadCount, }) => ({
        description: `${vehicleType} ${vehicleMake} ${vehicleModel}`,
        value: leadCount,
    })),
    lastUpdatedUTC: (data || {}).lastUpdatedUTC || '',
});
